import addDirctionaryModal from './addDirctionaryModal.vue';
import { typeList } from '../../insurance/templateManage/request.js';
import { getLibraryList, deleteLibrary } from './request.js';
export default {
  components: {
    addDirctionaryModal
  },
  data() {
    return {
      form: {
        name: undefined,
        field_category: 'all',
        type: undefined
      },
      typeList: typeList,
      columns: [{
        slots: {
          title: '序号'
        },
        dataIndex: 'index',
        key: '1',
        align: 'center',
        width: 80
      }, {
        slots: {
          title: '字段名称'
        },
        dataIndex: 'name',
        key: '2',
        align: 'center',
        ellipsis: true
      }, {
        slots: {
          title: '字段标识'
        },
        dataIndex: 'code',
        key: '3',
        align: 'center',
        ellipsis: true
      }, {
        slots: {
          title: '字段分类'
        },
        dataIndex: 'field_category',
        key: '4',
        align: 'center',
        ellipsis: true,
        scopedSlots: {
          customRender: 'field_category'
        }
      }, {
        slots: {
          title: '创建时间'
        },
        dataIndex: 'createAt',
        key: '5',
        align: 'center',
        ellipsis: true
      }, {
        slots: {
          title: '更新时间'
        },
        dataIndex: 'updateAt',
        key: '6',
        align: 'center',
        ellipsis: true
      }, {
        slots: {
          title: '操作'
        },
        key: '7',
        align: 'center',
        width: 300,
        scopedSlots: {
          customRender: 'action'
        }
      }],
      data: [],
      fieldCategoryInfo: {
        insurance_template: '投保模板',
        claims_param: '理赔参数',
        product_info: '产品信息',
        plan_info: '方案信息'
      },
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      visible: false,
      dictionaryRecord: {}
    };
  },
  mounted() {
    this.getFieldTable();
  },
  methods: {
    isShowDictionary(record) {
      if (record['display'] === 'RADIO' || record['display'] === 'CHECK') {
        return true;
      } else if (record['display'] === 'SELECT' && record['custom'] == '4') {
        return true;
      } else {
        return false;
      }
    },
    searchField() {
      this.pagination.current = 1;
      this.pagination.pageSize = 10;
      this.getFieldTable();
    },
    getFieldTable() {
      let params = {
        name: this.form.name,
        field_category: this.form.field_category === 'all' ? '' : this.form.field_category,
        type: this.form.type ? this.form.type : '',
        page: this.pagination.current,
        pageSize: this.pagination.pageSize
      };
      this.data = [];
      getLibraryList(params).then(res => {
        if (res) {
          this.data = res.items;
          this.pagination.total = res.totalNum;
        }
      });
    },
    getTemplateSelectOption(value) {
      if (1 !== value) {
        this.form.type = undefined;
      }
    },
    addField() {},
    handleStandardTableChange(val) {
      this.pagination = val;
      this.getFieldTable();
    },
    addDictionary(record) {
      this.visible = true;
      this.dictionaryRecord = record;
    },
    deleteField(id) {
      const h = this.$createElement;
      this.$confirm({
        title: this.$t('请谨慎操作'),
        icon: () => h("a-icon", {
          "class": "error-color",
          "attrs": {
            "type": "exclamation-circle"
          }
        }),
        content: this.$t('使用该字段的功能模块将会同步删除字段配置，请确认是否删除？'),
        okText: this.$t('删除'),
        cancelText: this.$t('取消'),
        onOk: () => {
          deleteLibrary({
            id
          }).then(res => {
            if (res === 1) {
              this.$message.success(this.$t('删除成功'));
              this.getFieldTable();
            }
          });
        },
        onCancel: () => {}
      });
    }
  }
};